// ===== FAKEDATA CLINIQUES (2 images par clinique) =====

// LOGOS (optionnels – remplace par tes vraies images)
// Importe tes vrais logos ici
 import logoEssalemSousse from "../../assets/icons/essalem-sousse-logo.png";
 import logoElYosr from "../../assets/icons/el-yosr-logo.png";
 import logoEssalemaSfax from "../../assets/icons/essalema-sfax-logo.png";
 import logoIbenNaffis from "../../assets/icons/iben-naffis-logo.png";
// IMAGES — mets 2 photos par clinique (facade, hall, bloc…)
import essalemSousse1 from "../../assets/icons/essalem-sousse-1.png";
import essalemSousse2 from "../../assets/icons/essalem-sousse-2.jpg";

import elYosr1 from "../../assets/icons/el-yosr-1.png";
import elYosr2 from "../../assets/icons/el-yosr-2.jpg";

import essalemaSfax1 from "../../assets/icons/essalema-sfax-1.jpg";
import essalemaSfax2 from "../../assets/icons/essalema-sfax-2.jpg";

import ibenNaffis1 from "../../assets/icons/iben-naffis-1.jpg";
import ibenNaffis2 from "../../assets/icons/iben-naffis-2.jpg";

// Fallbacks (si un logo manque)
import log1 from "../../assets/icons/log1.png";
import log2 from "../../assets/icons/log2.png";
import log3 from "../../assets/icons/log3.png";

export const LOGO_FALLBACKS = [log1, log2, log3];

// ===== Données =====
export const CLINICS_DATA = [
  {
    id: "c1",
    place_id: "clinic-essalem-sousse",
    kind: "clinic",
    name: "Clinique Essalem Sousse",
    type: "Private clinic",
    logo: logoEssalemSousse,
    images: [essalemSousse1, essalemSousse2],
    address: "Avenue Mohamed Karoui, Sahloul, Sousse",
    vicinity: "Sousse",
    phone: "+216 73 219 000",
    email: "contact@cliniqueessalem.tn",
    website: "https://clinique-essalem.com/",
    latitude: 35.829,
    longitude: 10.603,
    opening_hours: ["Monday to Saturday", "Open: 08:00 AM    Close: 06:00 PM"],
    is_open_now: true,
    whyChoose: {
      title: "Why choose ESSALEM Clinic?",
      description:
        "Clinique Essalem Sousse provides a modern and welcoming healthcare environment, featuring a multidisciplinary medical team specializing in cardiology, aesthetic surgery, pediatrics, and anesthesiology-resuscitation. Our commitment to patient-centered care, combined with state-of-the-art medical technology, ensures the highest standards of treatment and comfort for every patient.",
    },
    offeredServices: {
      title: "Offered services",
      description:
        "Essalem Clinic brings together comprehensive medical and surgical specialties, supported by advanced diagnostic equipment and a fully equipped emergency service available around the clock.",
      services: [
        "Cardiology",
        "Aesthetic Surgery",
        "Pediatrics",
        "Anesthesiology & Intensive Care",
        "Radiology & Medical Imaging",
      ],
    },
    contacts: {
      title: "Contacts of the clinic",
      description:
        "Contact us for any inquiries, medical consultations, or emergency assistance. Our dedicated team is ready to assist you promptly.",
      phone: "+216 73 219 000",
      email: "contact@cliniqueessalem.tn",
      address: "Avenue Mohamed Karoui, Sahloul, Sousse 4000",
      hours: "Open 24/7 - Seven days a week",
      mapUrl: "https://maps.google.com/?q=Clinique+Essalem+Sousse",
    },
  },
  {
    id: "c2",
    place_id: "clinic-elyosr-sousse",
    kind: "clinic",
    name: "Clinique El Yosr Sousse",
    type: "Private clinic",
    logo: logoElYosr,
    images: [elYosr2, elYosr1],
    address: "Avenue Hédi Chaker, Sousse",
    vicinity: "Sousse",
    phone: "+216 73 210 500",
    email: "info@cliniquelyosr.com",
    website: "https://www.clinique-elyosr-inter.com/",
    latitude: 35.828,
    longitude: 10.640,
    opening_hours: ["Monday to Saturday", "Open: 08:30 AM    Close: 06:30 PM"],
    is_open_now: true,
    whyChoose: {
      title: "Why choose El Yosr?",
      description:
        "A renowned healthcare institution in Sousse, Clinique El Yosr specializes in cardiac surgery, orthopedics, neurology, and functional rehabilitation. With 24/7 emergency services and a team of internationally trained specialists, we deliver excellence in complex medical procedures and post-operative care, ensuring optimal recovery outcomes for our patients.",
    },
    offeredServices: {
      title: "Offered services",
      description:
        "Comprehensive surgical center offering cutting-edge procedures, integrated medical imaging, and full-service laboratory facilities to support accurate diagnosis and effective treatment.",
      services: [
        "Cardiac & Vascular Surgery",
        "Orthopedics & Traumatology",
        "Neurology",
        "Functional Rehabilitation",
        "Medical Imaging & Laboratory",
      ],
    },
    contacts: {
      title: "Contacts of the clinic",
      description:
        "Our team remains available to answer your questions and schedule appointments. Reach out to us for professional medical guidance and care coordination.",
      phone: "+216 73 210 500",
      email: "info@cliniquelyosr.com",
      address: "Avenue Hédi Chaker, Sousse 4000",
      hours: "Open 24/7 - Seven days a week",
      mapUrl: "https://maps.google.com/?q=Clinique+El+Yosr+Sousse",
    },
  },
  {
    id: "c3",
    place_id: "clinic-essalema-sfax",
    kind: "clinic",
    name: "Clinique Essalema Sfax",
    type: "Private clinic",
    logo: logoEssalemaSfax,
    images: [essalemaSfax1, essalemaSfax2],
    address: "Route de Gabès, Km 3,5 – Sfax",
    vicinity: "Sfax",
    phone: "+216 74 439 000",
    email: "contact@cliniquessalema.tn",
    website: "https://polyclinique-essalama.com/",
    latitude: 34.7378,
    longitude: 10.7600,
    opening_hours: ["Monday to Saturday", "Open: 08:00 AM    Close: 06:00 PM"],
    is_open_now: true,
    whyChoose: {
      title: "Why choose Essalema Sfax?",
      description:
        "A modern multidisciplinary healthcare facility offering expertise in general surgery, internal medicine, gynecology-obstetrics, and intensive care. Equipped with the latest medical technology and staffed by experienced healthcare professionals, Clinique Essalema provides comprehensive care with a focus on patient safety, clinical excellence, and compassionate service.",
    },
    offeredServices: {
      title: "Offered services",
      description:
        "Multidisciplinary patient care supported by advanced medical imaging, modern surgical suites, and comprehensive diagnostic services to ensure accurate treatment and positive health outcomes.",
      services: [
        "General Surgery",
        "Gynecology & Obstetrics",
        "Intensive Care Unit",
        "Cardiology",
        "Radiology & Medical Imaging",
      ],
    },
    contacts: {
      title: "Contacts of the clinic",
      description:
        "Our attentive team is here to support you with emergency care and scheduled appointments. Contact us for expert medical consultation and personalized healthcare services.",
      phone: "+216 74 439 000",
      email: "contact@cliniquessalema.tn",
      address: "Route de Gabès, Km 3.5, Sfax",
      hours: "Open 24/7 - Seven days a week",
      mapUrl: "https://maps.google.com/?q=Polyclinique+Essalama+Sfax",
    },
  },
  {
    id: "c4",
    place_id: "clinic-ibennafis-sfax",
    kind: "clinic",
    name: "Clinique Iben Naffis Sfax",
    type: "Private clinic",
    logo: logoIbenNaffis,
    images: [ibenNaffis2, ibenNaffis1],
    address: "Route de Tunis Km 1, Sfax",
    vicinity: "Sfax",
    phone: "+216 74 233 200",
    email: "contact@cliniqueibnnafis.com",
    website: "https://polyclinique-ibn-annafis.com/",
    latitude: 34.750,
    longitude: 10.740,
    opening_hours: ["Monday to Saturday", "Open: 08:00 AM    Close: 06:00 PM"],
    is_open_now: true,
    whyChoose: {
      title: "Why choose Iben Naffis?",
      description:
        "Clinique Iben Naffis offers an extensive range of medical and surgical services, featuring a comprehensive imaging center, well-equipped emergency department, and intensive care facilities. Our dedicated medical staff combines clinical expertise with compassionate care, providing personalized treatment plans and ensuring the highest quality healthcare for patients across all age groups.",
    },
    offeredServices: {
      title: "Offered services",
      description:
        "Complete medical services including internal medicine, gastroenterology, advanced diagnostic imaging, and 24-hour emergency care with intensive care unit support.",
      services: [
        "Internal Medicine",
        "General Surgery",
        "Gastroenterology",
        "Radiology & CT Scan",
        "Intensive Care & Emergency Services",
      ],
    },
    contacts: {
      title: "Contacts of the clinic",
      description:
        "Contact the clinic for inquiries, medical guidance, and appointment scheduling. Our professional staff is committed to providing prompt and courteous assistance.",
      phone: "+216 74 233 200",
      email: "contact@cliniqueibnnafis.com",
      address: "Route de Tunis Km 1, Sfax",
      hours: "Open 24/7 - Seven days a week",
      mapUrl: "https://maps.google.com/?q=Clinique+Ibn+Naffis+Sfax",
    },
  },
];

// Export FAKE_CLINIQUES aussi pour rétrocompatibilité
export const FAKE_CLINIQUES = CLINICS_DATA;